export const getCertUrl = (certNumber, serviceName, grade) => {
  if (!certNumber) return null;
  
  if (serviceName === 'PCGS') {
    return `https://www.pcgs.com/cert/${certNumber}`;
  }
  
  if (serviceName === 'NGC') {
    // Extract numeric grade from strings like "MS61"
    const numericGrade = grade?.match(/\d+/)?.[0];
    return numericGrade 
      ? `https://www.ngccoin.com/certlookup/${certNumber}/${numericGrade}/`
      : `https://www.ngccoin.com/certlookup/${certNumber}/`;
  }
  
  return null;
};
